<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="25%"
    center
    class="Dialog"
    title="发票类型选择"
  >
    <div class="dialog-content">
      <!-- <el-select v-model="value" placeholder="请选择发票类型">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      <el-radio-group v-model="value" class="tradeType">
        <el-radio
          v-for="(item, index) in allOptions"
          :key="index"
          :label="item.value"
          style="display: block; margin: 10px 0"
          >{{ item.label }}</el-radio
        >
      </el-radio-group>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="chooseInvoiceHandler"
          >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  // , tableList

  export default {
    props: {
      extraOptions: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        load: false,
        options: [
          {
            value: '7',
            label: '增值税普通发票',
          },
          {
            value: '4',
            label: '增值税专用发票',
          },
          {
            value: '26',
            label: '电子普通发票',
          },
          {
            value: '28',
            label: '电子专用发票',
          },
        ],
        value: '',
        visible: false,
      };
    },
    computed: {
      allOptions() {
        return [...this.options, ...this.extraOptions];
      },
    },
    mounted() {},
    methods: {
      openDialog() {
        this.visible = true;
      },
      chooseInvoiceHandler() {
        if (!this.value) {
          this.$message.error('业务类别不能为空');
          return;
        }
        this.$emit('chooseInvoiceHandler', this.value);
        this.visible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
  .dialog-content {
    display: flex;
    justify-content: center;
  }
</style>
